import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const RulesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="rounded-md overflow-hidden border">
          <div className="bg-gradient-to-b from-[#C10930] to-[#6D081D] text-white font-extrabold px-4 py-3 text-lg">
            Rules &amp; Regulations
          </div>
          <div className="bg-white px-4 py-6 space-y-4 text-sm text-gray-800 leading-relaxed">
            <p>
              These rules &amp; regulations outline the general terms that apply when you use this platform.
              They are provided for guidance only and do not replace any official terms agreed with your operator.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li><span className="font-semibold">Fair Play:</span> All bets must be placed in good faith. Any attempt to exploit errors or delays may result in bets being voided.</li>
              <li><span className="font-semibold">Account Security:</span> You are responsible for keeping your login details confidential and for all activity performed under your account.</li>
              <li><span className="font-semibold">Responsible Gaming:</span> Bet only what you can afford to lose. Take regular breaks and use deposit or loss limits where available.</li>
              <li><span className="font-semibold">Settlement:</span> Markets are settled based on the official result published by the relevant governing body.</li>
              <li><span className="font-semibold">Disconnections:</span> In case of disconnection or technical issues, bets already accepted by the system will remain valid.</li>
            </ul>
            <p className="text-xs text-gray-500 mt-4">
              Note: This is example content for display purposes. Please replace it with your operator&apos;s
              official rules before going live.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Betting Guidelines</CardTitle>
            </CardHeader>
            <CardContent className="text-xs text-gray-700 space-y-1">
              <p>• Bets cannot be cancelled once confirmed.</p>
              <p>• In-play markets may suspend at any time during an event.</p>
              <p>• Void bets will be settled at odds of 1.00.</p>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Support</CardTitle>
            </CardHeader>
            <CardContent className="text-xs text-gray-700 space-y-1">
              <p>For any dispute or query, please contact your agent or support team with your Bet ID.</p>
              <p>Keep screenshots or reference numbers for faster resolution.</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default RulesPage;

